import { CHECKBOX_PARTS } from './checkboxParts';
import { DEFAULT_PROPS } from './const';
import type { CheckboxStyleConfig } from './types';

const BASE_STYLE: CheckboxStyleConfig['baseStyle'] = {
  container: {
    cursor: 'unset',

    _hover: {
      '.chakra-checkbox__control:not([data-readonly]):not([data-disabled])': {
        '&[data-checked]': {
          bg: 'interaction.hover',
          borderColor: 'interaction.hover',
        },
        '&:not([data-invalid])': {
          borderColor: 'interaction.hover',
        },
      },
    },
  },
  control: {
    alignSelf: 'flex-start',
    transition: 'box-shadow 250ms',
    bg: 'page.surface',
    border: '1px solid',
    borderRadius: 'sm',
    borderColor: 'separator.border',
    color: 'feature.onInteraction',
    cursor: 'pointer',

    _hover: {
      borderColor: 'interaction.hover',
    },

    _checked: {
      bg: 'interaction.main',
      borderColor: 'interaction.main',
      color: 'feature.onInteraction',

      _hover: {
        bg: 'interaction.hover',
        borderColor: 'interaction.hover',
      },

      _disabled: {
        bg: 'interaction.disabled',
        borderColor: 'interaction.disabled',
      },
    },

    _indeterminate: {
      bg: 'interaction.main',
      borderColor: 'interaction.main',
      color: 'feature.onInteraction',

      _hover: {
        bg: 'interaction.hover',
        borderColor: 'interaction.hover',
      },

      _disabled: {
        bg: 'interaction.disabled',
        borderColor: 'interaction.disabled',
      },
    },

    _disabled: {
      bg: 'interaction.surfaceDisabled',
      borderColor: 'interaction.disabled',
      cursor: 'not-allowed',
    },

    _focusVisible: {
      boxShadow: 'focus',
    },

    _invalid: {
      borderColor: 'alert.error',
    },

    _readOnly: {
      cursor: 'not-allowed',
      borderColor: 'feature.primary',

      _checked: {
        bg: 'feature.primary',
        borderColor: 'feature.primary',
      },

      _hover: {
        borderColor: 'feature.primary',
      },
    },
  },
  label: {
    alignSelf: 'flex-start',
    width: 'fit-content',
    maxWidth: '100%',
    userSelect: 'none',

    _disabled: { color: 'feature.secondary' },
  },
};

const SIZES = {
  sm: {
    control: { my: 0.5, h: 1.5, w: 1.5 },
    label: { fontSize: 'sm', lineHeight: 'sm', marginInlineStart: 0.75 },
    icon: { fontSize: '0.45rem' },
  },
  md: {
    control: { my: 0.5, w: 2, h: 2 },
    label: { fontSize: 'md', lineHeight: 'md', marginInlineStart: 1 },
    icon: { fontSize: '0.625rem' },
  },
  lg: {
    control: { my: 0.25, w: 2.5, h: 2.5 },
    label: { fontSize: 'lg', lineHeight: 'lg', marginInlineStart: 1 },
    icon: { fontSize: '0.625rem' },
  },
} as const;

export const CHECKBOX_STYLE_CONFIG: CheckboxStyleConfig = {
  parts: CHECKBOX_PARTS,
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
